import './Process.scss';

import ScriptIcon from "../resources/images/script.svg"
import VideoIcon from "../resources/images/camera.svg"
import EditIcon from "../resources/images/edit.svg"

function Process() {
    return (
        <div className="Process" id="process">
            {/* This used to carry the positioning sentence ("A Minneapolis video
                production service designed to communicate your mission through
                film."). That is a "what", and it now opens the page in Statement.
                What is left here is the "how" the three cards below actually
                describe. */}
            <div className="Process-header-container reveal">
                <span className="Process-eyebrow">How it works</span>
                <h2 className="Process-header">How a film <span>gets made.</span></h2>
                <p className="Process-lead">Three phases. You're in all of them.</p>
            </div>
            
            <div className="Process-box reveal left-box">
                <h3>Pre-Production</h3>
                <div className="img-container">
                    <img src={ScriptIcon} alt="Icon of a script and quill" />
                </div>
                <p>We discuss who you are, what story needs to be told, and who the target audience is.</p>
                <ul>
                    <li>Align on the budget</li>
                    <li>Write the script</li>
                </ul>
            </div>

            <div className="Process-box reveal delay-1 center-box">
                <h3>Production</h3>
                <div className="img-container">
                    <img src={VideoIcon} alt="Icon of movie camera" />
                </div>
                <p>It's time to capture your message in a way that beautifully serves your vision.</p>
                <ul>
                    <li>Record interviews</li>
                    <li>Capture extra footage</li>
                </ul>
            </div>

            <div className="Process-box reveal delay-2 right-box">
                <h3>Post-Production</h3>
                <div className="img-container">
                    <img src={EditIcon} alt="Icon of scissors cutting film" />
                </div>
                <p>The final step is compiling everything into a polished product that will make an impact.</p>
                <ul>
                    <li>Edits and color grade</li>
                    <li>Deliver final export</li>
                </ul>
            </div>

        </div>
    );
}

export default Process;
